import { Dispatch, FC, SetStateAction } from 'react'
import { Divider } from 'antd'
import {
  CountrySettingsFragment,
  LatestContractDtoFragment,
  FullMeetingFragment,
  GovernmentJobTitle,
  GovernmentJobTitleTinyDto,
} from '../../../types'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { ContractChangeTable } from './ContractChangeTable'
import useContractChanges from '../../../graphql/change/hooks/useContractChanges'
import { isGovernmentJobTitleValid, transformChangeData, transformFromStringToGovernmentJobTitle } from './helpers'

interface Props {
  meeting: FullMeetingFragment
  currentContract: LatestContractDtoFragment
  toggleExistingUnknownGovernmentJobTitle?: Dispatch<SetStateAction<boolean>>
  countrySettings: CountrySettingsFragment
  governmentJobTitles?: GovernmentJobTitle[]
}
export const ConclusionContractChanges: FC<Props> = ({
  meeting,
  currentContract,
  toggleExistingUnknownGovernmentJobTitle,
  countrySettings,
  governmentJobTitles,
}) => {
  const { loading, error, data } = useContractChanges(meeting.employee.id)

  if (loading || error || !data || !data.contractChangesByEmployee) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.contractChangesByEmployee} error={error} />
  }

  const transformedChangeData = transformChangeData(data.contractChangesByEmployee)

  if (!!toggleExistingUnknownGovernmentJobTitle && !!governmentJobTitles && countrySettings.hasGovernmentJobTitleReferenceLevel) {
    let atLeastOneUnknownGjt = false
    for (const change of transformedChangeData) {
      const parsedChange: GovernmentJobTitleTinyDto | undefined = transformFromStringToGovernmentJobTitle(
        JSON.parse(change.changes).governmentJobTitle,
      )
      if (!!parsedChange && !isGovernmentJobTitleValid(governmentJobTitles, parsedChange)) {
        atLeastOneUnknownGjt = true
        toggleExistingUnknownGovernmentJobTitle(true)
        break
      }
    }
    if (!atLeastOneUnknownGjt) {
      toggleExistingUnknownGovernmentJobTitle(false)
    }
  } else if (!!toggleExistingUnknownGovernmentJobTitle) {
    toggleExistingUnknownGovernmentJobTitle(false)
  }

  const contractChangesByEmployee = data.contractChangesByEmployee

  return (
    <>
      {contractChangesByEmployee && contractChangesByEmployee.length > 0 && (
        <>
          <ContractChangeTable
            meeting={meeting}
            type="conclusion"
            tableData={transformChangeData(contractChangesByEmployee)}
            currentContract={currentContract}
            isConclusion
            countrySettings={countrySettings}
            governmentJobTitles={governmentJobTitles}
          />
          <Divider />
        </>
      )}
    </>
  )
}
